import React from 'react'
import classNames from 'classnames'

export interface TextTableRowProps {
  className?: string
  children: React.ReactNode
}

export const TextTableRow: React.FC<TextTableRowProps> = (props) => {
  const { className, children } = props
  return <div className={classNames('table-row', className)}>{children}</div>
}
